export const ADDRESS_PARAM = 'address';
export const EAN_PARAM = 'ean';
export const INVOICE_PARAM = 'invoice';
export const CUSTOMER_TYPE_PARAM = 'customerType';

export const addressSearchParam = (addressIdentifier: string) => `?${ADDRESS_PARAM}=${addressIdentifier}`;

export const insertBusLabel = (address: string, busLabel: string) => {
  const addressParts = address.split(' ');
  const houseNumber = addressParts.find(part => part.match(/^\d+$/));
  if (!houseNumber) return address;
  const busLabelIndex = addressParts.indexOf(houseNumber) + 1;
  addressParts.splice(busLabelIndex, 0, busLabel);
  return addressParts.join(' ');
};

export const eanSearchParam = (ean: string) => `${EAN_PARAM}=${ean}`;

export const rectificationInvoiceSearchParam = (invoiceId?: string | null) => `?${INVOICE_PARAM}=${invoiceId}`;
